import { useEffect } from "react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";

import { appVersion, viteMode } from "utils/env";
import App from "./App";
import "./index.scss";

if (viteMode === "production") {
  Sentry.init({
    dsn: "https://15b4641ce7bc4268b44a062b86225603@o1195569.ingest.sentry.io/6318695",
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1,
    release: appVersion,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(<App />);
